import _regeneratorRuntime from "/workspace/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/workspace/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { App } from '@aragon/connect-core';

function _parseApp(_x, _x2) {
  return _parseApp2.apply(this, arguments);
}

function _parseApp2() {
  _parseApp2 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(app, organization) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, data;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            data = {
              address: app.address,
              appId: app.appId,
              artifact: (_a = app.version) === null || _a === void 0 ? void 0 : _a.artifact,
              codeAddress: app.implementation.address,
              contentUri: (_b = app.version) === null || _b === void 0 ? void 0 : _b.contentUri,
              isForwarder: app.isForwarder,
              isUpgradeable: app.isUpgradeable,
              kernelAddress: (_c = app.organization) === null || _c === void 0 ? void 0 : _c.address,
              manifest: (_d = app.version) === null || _d === void 0 ? void 0 : _d.manifest,
              name: app.repoName,
              registry: (_f = (_e = app.repo) === null || _e === void 0 ? void 0 : _e.registry) === null || _f === void 0 ? void 0 : _f.name,
              registryAddress: (_h = (_g = app.repo) === null || _g === void 0 ? void 0 : _g.registry) === null || _h === void 0 ? void 0 : _h.address,
              repoAddress: (_j = app.repo) === null || _j === void 0 ? void 0 : _j.address,
              version: (_k = app.version) === null || _k === void 0 ? void 0 : _k.semanticVersion.replace(/,/g, '.')
            };
            return _context.abrupt("return", App.create(data, organization));

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _parseApp2.apply(this, arguments);
}

export function parseApp(_x3, _x4) {
  return _parseApp3.apply(this, arguments);
}

function _parseApp3() {
  _parseApp3 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2(result, organization) {
    var _a, app;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            app = (_a = result === null || result === void 0 ? void 0 : result.data) === null || _a === void 0 ? void 0 : _a.app;

            if (app) {
              _context2.next = 3;
              break;
            }

            throw new Error('Unable to parse app.');

          case 3:
            return _context2.abrupt("return", _parseApp(app, organization));

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _parseApp3.apply(this, arguments);
}

export function parseApps(_x5, _x6) {
  return _parseApps.apply(this, arguments);
}

function _parseApps() {
  _parseApps = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee4(result, organization) {
    var _a, _b, apps;

    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            apps = (_b = (_a = result === null || result === void 0 ? void 0 : result.data) === null || _a === void 0 ? void 0 : _a.organization) === null || _b === void 0 ? void 0 : _b.apps;

            if (apps) {
              _context4.next = 3;
              break;
            }

            throw new Error('Unable to parse apps.');

          case 3:
            return _context4.abrupt("return", Promise.all(apps.map(
            /*#__PURE__*/
            function () {
              var _ref = _asyncToGenerator(
              /*#__PURE__*/
              _regeneratorRuntime.mark(function _callee3(app) {
                return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        return _context3.abrupt("return", _parseApp(app, organization));

                      case 1:
                      case "end":
                        return _context3.stop();
                    }
                  }
                }, _callee3);
              }));

              return function (_x7) {
                return _ref.apply(this, arguments);
              };
            }())));

          case 4:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _parseApps.apply(this, arguments);
}